<template>
  <div v-if="column.field != null" class="px-1" :class="$attrs.class">
    <InvoiceTitleElement
      v-if="column.type === 'title'"
      class="flex-column flex truncate dark:border-white dark:bg-slate-700 dark:text-gray-300"
      :column="column"
      :invoice="invoice"
    />
    <div v-else-if="column.type === 'avatar'" class="flex justify-center px-1">
      <UserAvatarPopover
        v-if="['dossier#responsable#id'].includes(column.field)"
        :user-id="invoice[column.field]"
      />
      <FuneralHomeAvatar
        v-else-if="['funeral_home_id'].includes(column.field)"
        :id="invoice[column.field]"
      />
      <img
        v-else
        class="mx-auto h-8 w-8 rounded-full shadow-md ring-2 ring-white"
        :src="invoice[column.field]"
        alt="##"
      />
    </div>
    <DateTimeFormatter
      v-else-if="column.type === 'date'"
      :date-time="invoice[column.field]"
      format="DD MMM YYYY[</br>]HH:mm"
      classes="text-xs font-medium leading-4 dark:border-slate-300 dark:bg-slate-700 dark:text-gray-300 truncate"
    />
    <AmountFormatter
      v-else-if="column.type === 'currency'"
      :amount="invoice[column.field]"
      :currency="invoice['currency']"
      class="truncate leading-4 font-medium dark:border-slate-300 dark:bg-slate-700 dark:text-gray-300"
      :class="$attrs.class"
    />
    <BaseLabel
      v-else-if="column.type === 'label' && invoice[column.field] != null"
      :icon="column.field ? column.field.icon : null"
      :content="column.field ? (invoice[column.field]?.value ?? '---') : '---'"
      :color="column.field ? (invoice[column.field]?.color ?? '---') : '---'"
    />
    <div
      v-else-if="column.type === 'text'"
      class="truncate dark:border-slate-300 dark:bg-slate-700 dark:text-gray-300"
      v-text="invoice[column.field]"
    />
    <ModalComponent
      v-else-if="column.type === 'modal_infos'"
      :column="column"
      :dossier="invoice"
    />
    <template
      v-else-if="column.type === 'link' && invoice[column.field] != null"
    >
      <RouterLink
        v-if="invoice[column.field].router"
        :to="invoice[column.field].router"
        class="truncate font-semibold text-primary"
      >
        {{ invoice[column.field]?.label ?? $t('button.navigate') }}
      </RouterLink>
      <div
        v-else
        class="truncate dark:border-slate-300 dark:bg-slate-700 dark:text-gray-300"
        v-text="invoice[column.field]?.label"
      />
    </template>
  </div>
</template>
<script>
import AvatarComponent from '@c/AvatarComponent'
import DateTimeFormatter from '@c/DateTimeFormatter'
import { mapGetters } from 'vuex'
import BaseLabel from '@c/addf-package/components/BaseLabel/BaseLabel.vue'
import InvoiceTitleElement from '@c/Dashboard/Content/Invoicing/components/Body/components/InvoiceTitleElement.vue'
import AmountFormatter from '@c/AmountFormatter.vue'
import FuneralHomeAvatar from '@c/Avatar/FuneralHomeAvatar.vue'
import UserAvatarPopover from '@c/Avatar/Popover/UserAvatarPopover.vue'
import ModalComponent from '@c/Dashboard/Content/Dossier/components/Body/ModalComponent.vue'

export default {
  name: 'InvoiceRowElement',
  components: {
    UserAvatarPopover,
    FuneralHomeAvatar,
    AmountFormatter,
    InvoiceTitleElement,
    BaseLabel,
    DateTimeFormatter,
    ModalComponent
  },
  props: {
    column: { type: Object, required: true },
    invoice: { type: Object, required: true },
    indexInvoice: { type: Number, required: true },
    indexcolumn: { type: Number, required: true }
  },
  emits: ['toggleTasks'],
  computed: {
    ...mapGetters({
      dossierList: 'dossier/getDossierIndex',
      dossierMetadata: 'dossier/getDossierMetadata'
    }),
    filterdTask() {
      return this.dossier.tasks?.find((task) => {
        return task.task_id === this.column.field
      })
    }
  }
}
</script>
